"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("underscore");
var Scheme;
(function (Scheme) {
    Scheme[Scheme["http"] = 0] = "http";
    Scheme[Scheme["https"] = 1] = "https";
})(Scheme = exports.Scheme || (exports.Scheme = {}));
// regex to split urls into components
var urlregex = /^(http:\/\/|https:\/\/)([^:\/]+)(:[0-9]+){0,1}(\/[^?]*){0,1}(\?[^#]*){0,1}/;
// tslint:disable:no-invalid-this
function parseUrl(url) {
    var matches = urlregex.exec(url);
    if (matches) {
        var schemestring = matches[1].substr(0, matches[1].length - 3);
        var host = matches[2];
        var port = matches[3];
        return {
            scheme: Scheme[schemestring],
            hostname: host,
            port: port ? parseInt(port.substr(1), 10) : undefined,
            path: matches[4],
            query: matches[5] ? parseQuery(matches[5].substr(1)) : undefined,
            format: function () { return formatUrl(this); }
        };
    }
    return null;
}
exports.parseUrl = parseUrl;
// tslint:enable:no-invalid-this
function parseQuery(query) {
    if (!query) {
        return undefined;
    }
    return _.object(_.map(query.split('&'), function (exp) {
        return _.map(exp.split(/=(.+)?/, 2), function (v, i) { return i === 0 ? v : decodeURIComponent(v); });
    }));
}
exports.parseQuery = parseQuery;
function formatUrl(url) {
    var querystring = '';
    if (url.query) {
        querystring = "?" + (_.isString(url.query) ? url.query : formatQuery(url.query));
    }
    var schemestring = _.isString(url.scheme) ? url.scheme : Scheme[url.scheme];
    return schemestring + "://" + url.hostname + (_.isUndefined(url.port) ? '' : ":" + url.port) + (url.path || '') + querystring;
}
function formatQuery(obj) {
    return Object.keys(obj).map(function (k) { return k + "=" + encodeURIComponent(obj[k]); }).join('&');
}
exports.formatQuery = formatQuery;
//# sourceMappingURL=url.js.map